// Cómo se llaman en pantalla las cifras que este módulo sabe medir.
//
// Un CONTRATO con `backend/analytics.js`: cada `labelKey` que aquel fichero
// declara tiene aquí su traducción en los cuatro idiomas. La ayuda de un
// dataset dice qué es UNA FILA, que es lo que distingue dos parecidos.

const analytics = {
  es: {
    conversations: { label: 'Conversaciones', help: 'Una fila por conversación del canal: privada, de grupo o sobre un registro. Nunca por persona' },
    calls: { label: 'Llamadas', help: 'Una fila por llamada: contestadas, perdidas, convertidas en nota de voz, minutos y, hasta Radio 0.5.0, relevo TURN' },
    extractions: { label: 'Lo que ha propuesto el asistente', help: 'Una fila por cada vez que el asistente leyó un trozo de conversación: propuestas, aceptadas y coste' },
    dates: { created: 'Fecha en que empezó', lastMessage: 'Último mensaje', started: 'Fecha de la llamada', read: 'Fecha de la lectura' },
    metrics: {
      conversations: 'Conversaciones', messages: 'Mensajes', members: 'Personas por conversación', copilotOff: 'Con el asistente apagado',
      aiCost: 'Coste de IA', calls: 'Llamadas', answered: 'Contestadas', missed: 'Perdidas', declined: 'Rechazadas u ocupado',
      voicemail: 'Convertidas en nota de voz', failed: 'Fallidas', minutes: 'Minutos hablados', avgMinutes: 'Minutos por llamada',
      relayed: 'Por el relevo TURN', relayMb: 'Tráfico por el relevo (MB)', recorded: 'Grabadas',
      voicemailRate: 'Perdidas que acabaron en nota de voz', relayRate: 'Llamadas por el relevo',
      extractions: 'Lecturas', proposals: 'Propuestas', accepted: 'Aceptadas (apuntes en el ERP)', rejected: 'Descartadas',
      expired: 'Caducadas', pending: 'Pendientes', failedProposals: 'Aceptadas que no se pudieron hacer', readCost: 'Coste de leer',
      tokens: 'Tokens', acceptanceRate: 'Porcentaje aceptadas',
    },
    dimensions: {
      kind: 'Tipo de conversación', subjectType: 'Tipo de registro', subject: 'Registro', callKind: 'Audio o vídeo',
      outcome: 'Cómo acabó', endReason: 'Por qué acabó', trigger: 'Qué hizo leer', state: 'Estado',
    },
  },

  ca: {
    conversations: { label: 'Converses', help: 'Una fila per conversa del canal: privada, de grup o sobre un registre. Mai per persona' },
    calls: { label: 'Trucades', help: 'Una fila per trucada: contestades, perdudes, convertides en nota de veu, minuts i, fins a Radio 0.5.0, relleu TURN' },
    extractions: { label: 'El que ha proposat l’assistent', help: 'Una fila per cada cop que l’assistent va llegir un tros de conversa: propostes, acceptades i cost' },
    dates: { created: 'Data en què va començar', lastMessage: 'Últim missatge', started: 'Data de la trucada', read: 'Data de la lectura' },
    metrics: {
      conversations: 'Converses', messages: 'Missatges', members: 'Persones per conversa', copilotOff: 'Amb l’assistent apagat',
      aiCost: 'Cost d’IA', calls: 'Trucades', answered: 'Contestades', missed: 'Perdudes', declined: 'Rebutjades o ocupat',
      voicemail: 'Convertides en nota de veu', failed: 'Fallides', minutes: 'Minuts parlats', avgMinutes: 'Minuts per trucada',
      relayed: 'Pel relleu TURN', relayMb: 'Trànsit pel relleu (MB)', recorded: 'Enregistrades',
      voicemailRate: 'Perdudes que van acabar en nota de veu', relayRate: 'Trucades pel relleu',
      extractions: 'Lectures', proposals: 'Propostes', accepted: 'Acceptades (apunts a l’ERP)', rejected: 'Descartades',
      expired: 'Caducades', pending: 'Pendents', failedProposals: 'Acceptades que no es van poder fer', readCost: 'Cost de llegir',
      tokens: 'Tokens', acceptanceRate: 'Percentatge acceptades',
    },
    dimensions: {
      kind: 'Tipus de conversa', subjectType: 'Tipus de registre', subject: 'Registre', callKind: 'Àudio o vídeo',
      outcome: 'Com va acabar', endReason: 'Per què va acabar', trigger: 'Què va fer llegir', state: 'Estat',
    },
  },

  en: {
    conversations: { label: 'Conversations', help: 'One row per conversation in the channel: private, group or about a record. Never by person' },
    calls: { label: 'Calls', help: 'One row per call: answered, missed, turned into a voice note, minutes and, up to Radio 0.5.0, TURN relay' },
    extractions: { label: 'What the assistant proposed', help: 'One row per time the assistant read a stretch of conversation: proposals, accepted and cost' },
    dates: { created: 'Date it started', lastMessage: 'Last message', started: 'Date of the call', read: 'Date it was read' },
    metrics: {
      conversations: 'Conversations', messages: 'Messages', members: 'People per conversation', copilotOff: 'With the assistant off',
      aiCost: 'AI cost', calls: 'Calls', answered: 'Answered', missed: 'Missed', declined: 'Declined or busy',
      voicemail: 'Turned into a voice note', failed: 'Failed', minutes: 'Minutes talking', avgMinutes: 'Minutes per call',
      relayed: 'Through the TURN relay', relayMb: 'Relay traffic (MB)', recorded: 'Recorded',
      voicemailRate: 'Missed calls that became a voice note', relayRate: 'Calls through the relay',
      extractions: 'Reads', proposals: 'Proposals', accepted: 'Accepted (records in the ERP)', rejected: 'Dismissed',
      expired: 'Expired', pending: 'Pending', failedProposals: 'Accepted but could not be done', readCost: 'Cost of reading',
      tokens: 'Tokens', acceptanceRate: 'Acceptance rate',
    },
    dimensions: {
      kind: 'Kind of conversation', subjectType: 'Kind of record', subject: 'Record', callKind: 'Audio or video',
      outcome: 'How it ended', endReason: 'Why it ended', trigger: 'What made it read', state: 'State',
    },
  },

  fr: {
    conversations: { label: 'Conversations', help: 'Une ligne par conversation du canal : privée, de groupe ou sur un enregistrement. Jamais par personne' },
    calls: { label: 'Appels', help: 'Une ligne par appel : répondus, manqués, transformés en note vocale, minutes et, jusqu’à Radio 0.5.0, relais TURN' },
    extractions: { label: 'Ce que l’assistant a proposé', help: 'Une ligne par lecture d’un morceau de conversation par l’assistant : propositions, acceptées et coût' },
    dates: { created: 'Date de début', lastMessage: 'Dernier message', started: 'Date de l’appel', read: 'Date de la lecture' },
    metrics: {
      conversations: 'Conversations', messages: 'Messages', members: 'Personnes par conversation', copilotOff: 'Avec l’assistant éteint',
      aiCost: 'Coût de l’IA', calls: 'Appels', answered: 'Répondus', missed: 'Manqués', declined: 'Refusés ou occupé',
      voicemail: 'Transformés en note vocale', failed: 'Échoués', minutes: 'Minutes de conversation', avgMinutes: 'Minutes par appel',
      relayed: 'Par le relais TURN', relayMb: 'Trafic par le relais (Mo)', recorded: 'Enregistrés',
      voicemailRate: 'Manqués devenus note vocale', relayRate: 'Appels par le relais',
      extractions: 'Lectures', proposals: 'Propositions', accepted: 'Acceptées (saisies dans l’ERP)', rejected: 'Écartées',
      expired: 'Expirées', pending: 'En attente', failedProposals: 'Acceptées mais impossibles à faire', readCost: 'Coût de la lecture',
      tokens: 'Jetons', acceptanceRate: 'Taux d’acceptation',
    },
    dimensions: {
      kind: 'Type de conversation', subjectType: 'Type d’enregistrement', subject: 'Enregistrement', callKind: 'Audio ou vidéo',
      outcome: 'Comment il s’est terminé', endReason: 'Pourquoi il s’est terminé', trigger: 'Ce qui a déclenché la lecture', state: 'État',
    },
  },
}

/** Añade el vocabulario de analítica al catálogo del módulo, idioma a idioma. */
export function withAnalytics(base, namespace) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      [namespace]: { ...catalogue[namespace], analytics: analytics[locale] },
    }
  }
  return merged
}

export default analytics
